import Utility from "../../../logic/Utility";
import Analytics from "../../../../../utils/Analytics";
import { useSliderState } from "../../slider/SliderState";
import localization from "../../../../../assets/localization";

export default function MessageCTAs({
  template,
  threadId,
  assistantId,
  isMobile,
}: any) {
  const sliderState = useSliderState();
  return (
    <div className="message-template-ctas">
      {template.ctas.map((cta: any, ctaIndex: any) => {
        if (cta.type === "url") {
          return (
            <a
              key={ctaIndex}
              href={Utility.getWithParams(
                cta.link,
                assistantId,
                threadId,
                cta.key === "quick_quote"
              )}
              target="_blank"
              style={{ textDecoration: "none" }}
              rel="noopener noreferrer"
              onClick={() =>
                Analytics.track("link_click", {
                  url: cta.link,
                  cta: cta.key,
                  source: "message_cta",
                })
              }
            >
              <button className="message-template-cta-button">
                {localization.get(sliderState.language)[cta.key]}
                <i className="fa-solid fa-chevron-right"></i>
              </button>
            </a>
          );
        } else if (cta.type === "slider_trigger") {
          return (
            <button
              key={ctaIndex}
              className="message-template-cta-button"
              onClick={() => {
                // In-widget CTA (e.g. HM "look at the photos"): same intent
                // as reopening content from chat, not an outbound link.
                Analytics.track("anchor_click", {
                  template_type: template?.type ?? null,
                  source: "slider_trigger",
                });
                sliderState.openSlider(
                  threadId,
                  assistantId,
                  template,
                  isMobile
                );
              }}
            >
              {localization.get(sliderState.language)[cta.key]}
              <i className="fa-solid fa-chevron-right"></i>
            </button>
          );
        } else {
          return null;
        }
      })}
    </div>
  );
}
